export default __webpack_public_path__ + "static/media/logotype.56da8ef3.jpg";